import { render, staticRenderFns } from "./RoleAndPermission.vue?vue&type=template&id=08bf73aa&scoped=true"
import script from "./RoleAndPermission.vue?vue&type=script&lang=js"
export * from "./RoleAndPermission.vue?vue&type=script&lang=js"
import style0 from "./RoleAndPermission.vue?vue&type=style&index=0&id=08bf73aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf73aa",
  null
  
)

export default component.exports